module.exports = __webpack_public_path__ + "static/media/icon-sidebar-small.8f5e4e0e.png";